
<modal :state="state" :index="index" @toggle-modal="emitHideModal">
  <div slot="body">
    <h3 class="modal-title">{{errorTitle}}</h3>
    <p>{{errorMessage}}</p>
    <div class="cta">
      <button type="button" @click="emitHideModal" class="btn block green">Close</button>
    </div>
  </div>
</modal>
